import { Injectable } from '@angular/core';


@Injectable()
export class AuthService {
  constructor() {}

  // Logout
  doLogout() {
    return new Promise<void>((resolve, reject) => {
      sessionStorage.clear();
      resolve();
    });
  }

}
